import { render, staticRenderFns } from "./SmartPillboxData.vue?vue&type=template&id=60c2d770&scoped=true"
import script from "./SmartPillboxData.vue?vue&type=script&lang=js"
export * from "./SmartPillboxData.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxData.vue?vue&type=style&index=0&id=60c2d770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2d770",
  null
  
)

export default component.exports